import { getPropertyTypeMap } from '../model/option'
import { TRoomDetail } from '../model/schema'

export const generateRoomMetadata = async (
  room: Pick<
    TRoomDetail,
    'state' | 'province' | 'town' | 'propertyType' | 'roomName' | 'pictures'
  >,
) => {
  const { PROPERTY_TYPE_MAP } = await getPropertyTypeMap()

  const title = `[삼삼엠투] ${room.state} ${room.province} ${room.town} ${PROPERTY_TYPE_MAP[room.propertyType]} 단기임대 | ${room.roomName}`

  return {
    title,
    openGraph: {
      title,
      images: [
        `https://${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/${room.pictures[0]}`,
      ],
    },
  }
}
